import React, { useMemo } from 'react';
import { SubscriptionTableFlatContainer } from '@css-xp/ppc-subscription-table';
import { CreditCard, PaymentOnTerms, Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import { SUBSCRIPTION_CONSTANTS } from '@css-xp/ppc-constants';
import { useFetchInvoiceGroupBySoldToAddressQuery } from '../hooks/use-fetch-invoice-group-by-sold-to-address-query';

interface Props {
  transactionAccountId: string;
  soldToAddressIds: string[];
  availablePaymentMethods?: Maybe<Maybe<PaymentOnTerms | CreditCard>[]> | undefined;
  label?: string;
  shouldHideTabs?: boolean;
  shouldHideCustomiseView?: boolean;
  isSandboxSupportForSubscriptionsEnabled?: boolean;
  isInternalUsageLicensesEnabled: boolean;
  isSupportForExternallyBilledEnabled?: boolean;
  isTWCPhase1Enabled?: boolean;
  isFutureDatedSubscriptionsEnabled?: boolean;
}

export const SubscriptionTableSoldToAddress = ({
  soldToAddressIds,
  transactionAccountId,
  label,
  shouldHideTabs,
  shouldHideCustomiseView,
  isSandboxSupportForSubscriptionsEnabled,
  isInternalUsageLicensesEnabled,
  isSupportForExternallyBilledEnabled = false,
  isTWCPhase1Enabled = false,
  isFutureDatedSubscriptionsEnabled = false,
}: Props) => {
  const { data: invoiceGroupsData, loading, error } = useFetchInvoiceGroupBySoldToAddressQuery({ soldToAddressIds });

  const entitlementFilterOptions = useMemo(
    () => [
      {
        key: 'invoiceGroupIdIsIn',
        values: invoiceGroupsData?.invoiceGroupsForShipToPartyIds?.shipToPartiesBillingGroupIds ?? [],
      },
    ],
    [invoiceGroupsData]
  );

  return (
    <SubscriptionTableFlatContainer
      transactionAccountId={transactionAccountId}
      isFreeTabEnabled={false}
      filterOptions={entitlementFilterOptions}
      loading={loading}
      error={error}
      label={label}
      shouldHideTabs={shouldHideTabs}
      shouldHideCustomiseView={shouldHideCustomiseView}
      isSandboxSupportForSubscriptionsEnabled={isSandboxSupportForSubscriptionsEnabled}
      isInternalUsageLicensesEnabled={isInternalUsageLicensesEnabled}
      isSupportForExternallyBilledSubscriptionsEnabled={isSupportForExternallyBilledEnabled}
      isTWCPhase1Enabled={isTWCPhase1Enabled}
      isFutureDatedSubscriptionsEnabled={isFutureDatedSubscriptionsEnabled}
    />
  );
};
